import React from 'react';
import { Navigate } from 'react-router-dom';

// /shift 入口：一律進統一主頁（分頁依登入角色）
export default function ShiftIndex() {
  return <Navigate to="/shift/home" replace />;
}
